import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const storedIsAuth = Cookies.get("isAuth");

interface AuthState {
  isAuth: boolean;
  isLoading: boolean;
}
interface AuthStoreState {
  token: string | null;
  role: "ADMIN" | "MANAGER" | null;
  permissions: string[];
  login: (
    token: string,
    role: "ADMIN" | "MANAGER",
    permissions: string[],
  ) => void;
  logout: () => void;
}

const initialState: AuthState = { isAuth: !!storedIsAuth, isLoading: false };

export const authSlice = createSlice({
  initialState,
  name: "auth",
  reducers: {
    setAuth: (state, action) => {
      state.isAuth = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setAuth, setLoading } = authSlice.actions;
export default authSlice.reducer;

export const useAuthStore = create<AuthStoreState>()(
  persist(
    set => ({
      login: (token, role, permissions) => set({ permissions, role, token }),
      logout: () => {
        set(() => ({
          permissions: [],
          role: null,
          token: null,
        }));
      },
      permissions: [],
      role: null,
      token: null,
    }),
    {
      name: "auth-store",
    },
  ),
);
